import {useEffect} from 'react';
import {useLatest} from 'react-use';

import useTracking from '@/hooks/useTracking';
import {NAVLINK_TRACKING} from '../appBarTracking';
import useNavLinkTracking from '../hooks/useNavlinkTracking';

type NotificationsOpenTrackerProps = {
  area: 'desktop' | 'mobile';
  version: string;
};

const NotificationsOpenTracker: React.FC<NotificationsOpenTrackerProps> = ({area, version}) => {
  const {track} = useTracking();
  const {trackRumAction} = useNavLinkTracking();

  const trackRef = useLatest(track);
  const trackRumActionRef = useLatest(trackRumAction);

  useEffect(() => {
    trackRef.current?.(NAVLINK_TRACKING.notifications.dropdownOpened, {
      url: window.location.href,
      misc_json: JSON.stringify({area, version}),
    });

    if (area === 'desktop') {
      trackRumActionRef.current?.({
        datadogAction: NAVLINK_TRACKING.notifications.hovered,
        version,
      });
    }
  }, [area, version, trackRef, trackRumActionRef]);

  return null;
};

export default NotificationsOpenTracker;
